<template>
  <el-popover
    v-if="toUsers && toUsers.length"
    placement="top-start"
    width="400"
    trigger="click"
    title="Danh sách: "
  >
    <div v-for="(item, index) in toUsers" :key="item.id">
      <p class="select-signer">
        {{ index + 1 }}.
        <span>
          {{ item.toFullName }}
          <em class="font-weight__bold font-size__small"
          >({{ item.toPositionName + " - " + item.toDeptName }})</em
          >
        </span>
      </p>
    </div>
    <span slot="reference">
      <i class="fas fa-info-circle color__yellow"></i>
    </span>
  </el-popover>
</template>

<script>
  export default {
    name: "comment-receivers-info",
    props: ["toUsers"]
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/comment-receivers-info.vue